<template>
    <slot name="filter-field-multiselector-option" v-bind="this"></slot>
</template>


<script>
    export default {
        props: {
            modelValue: null,
            name: null,
            option: null,
            index: null
        },
        data() {
            return {
                checked: this.option.checked || false,
                isChecked: this.option.checked || false
            }
        },
        watch: {
            checked(newValue) {
                this.$emit( 'input', newValue );
            },
            value(newValue) {
                this.checked = newValue
            }
        },
        methods: {
            change(option) {
                this.checked = !this.checked;
                this.option.checked = this.checked;
                this.$emit('change', this.option);
                this.isChecked = this.checked;
            },


        },

    };
</script>







